import React from "react";
import { Link } from "react-router-dom";
import { IoLogInOutline, IoStorefrontOutline } from "react-icons/io5";
import "../Home.css";

const DASHBOARD_PREVIEW = "/images/business-analytics-preview.png";

export default function ShopOwnerSection({ t, lang }) {
  return (
    <section
      className="shop-owner-section container scroll-animate from-right"
      id="business-sign-in"
      aria-labelledby="shop-owner-title"
      dir={lang === "ar" ? "rtl" : "ltr"}
    >
      <div className="shop-owner-container scroll-animate from-right delay-2">
        <div className={`shop-owner-cta shop-owner-cta--light ${lang === "ar" ? "shop-owner-left-card-rtl" : ""}`}>
          <h2
            id="shop-owner-title"
            className="home-section-title shop-owner-section-title shop-owner-cta-title scroll-animate from-right delay-1"
          >
            {t.shopOwnerTitle}
          </h2>
          <p className="shop-owner-intro shop-owner-cta-intro scroll-animate from-right delay-1-5">
            {t.shopOwnerIntro}
          </p>
          <div className="shop-owner-buttons-row">
            <Link to="/ShopOwnerDashboard" className="shop-owner-sign-in-button shop-owner-sign-in-button-inline">
              <IoLogInOutline className="shop-owner-btn-icon" />
              {t.shopOwnerSignIn}
            </Link>
            <Link to="/ListUrBussiness" className="shop-owner-list-business-button">
              <IoStorefrontOutline className="shop-owner-btn-icon" />
              {t.listBiz}
            </Link>
          </div>
        </div>

        <div className="shop-owner-right-card">
          <img
            src={DASHBOARD_PREVIEW}
            alt={lang === "ar" ? "معاينة لوحة تحليلات احجزلي" : "Ehgezly business analytics preview"}
            className="shop-owner-preview-image"
          />
        </div>
      </div>
    </section>
  );
}
